import store from '@/store';
import { IStoreReady } from '@/store/lib/storeSupport';
import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
import {IServices, IServicesListItem} from '@/entity/services/services.types';
import {PaginationRequestType} from "@/entity/common/pagination.types";

import {
    ServiceNomenclatureCreateRequestType,
    ServiceCreateRequestTypeCopy,
    ServiceCreateRequestType
} from '@/form/serviceCreate/serviceCreate.types';
import { ServiceAvailableRequestType } from '@/form/serviceAvailableCopy/serviceAvailable.type';

import {ResponseDataType} from "@/form/form.types";
import { prepareFormData } from '@/store/utils/formDataHelper'
@Module({
    namespaced: true,
    name: 'services',
    store,
    dynamic: true
})

class ServiceModule extends VuexModule implements IStoreReady {
    service: IServices | null = null
    services:  IServicesListItem | null = null
    serviceLoaded   = false
    servicesLoaded  = false
    ready = false


    @Action
    async add(item:IServicesListItem){
        this.service?.data.push(item)
    }



    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ service: IServices;  serviceLoaded: boolean }> {

        let serviceLoaded = false;
        const service = await store.$repository.services.fetchAll(prepareFormData(data));
        if(service){
            serviceLoaded = true;
        }
        return { service, serviceLoaded}
    }

    @MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ services: IServicesListItem  ; servicesLoaded: boolean }> {
        let servicesLoaded = false;
        const services = await store.$repository.services.fetchData(data);
        if (services) {
            servicesLoaded = true;
        }
        return { services, servicesLoaded};
    }

    @Action({rawError: true})
    async copy(data: ServiceAvailableRequestType): Promise<ResponseDataType>{
        return await store.$repository.services.copy(data);
    }

    @Action({rawError: true})
    async create(data: ServiceCreateRequestType): Promise<ResponseDataType> {
        return  await store.$repository.services.create(data);
    }

    @Action({rawError: true})
    async update(data: ServiceCreateRequestType): Promise<ResponseDataType> {
        return await store.$repository.services.update(data);
    }
    @Action({rawError: true})
    async delete(data: {id: number}): Promise<ResponseDataType> {
        return  await store.$repository.services.delete(data);
    }
    @Mutation
    setReady(st:boolean){
        this.ready = st
    }
}

export const ServiceStore = getModule(ServiceModule);